import TelecomDto from './TelecomDto'

export default class TelecomAssignatedDto extends TelecomDto {
    constructor(obj) {
        super(obj)
        this.siteCode = obj.siteCode
        this.situationDate = obj.situationDate
    }
}
